import CategoryExceptions from "../constants/categoryExceptions";

export const isBigCardOrNot = (slug) => {
  return CategoryExceptions.showBigCard.includes(slug);
};
